var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBayAtm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.954,
    height: 45,
    viewBox: "0 0 44.954 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BAYATM",
    transform: "translate(-139.982 -69.775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M228.88,186.031a.918.918,0,0,0,.919.919H253.89a.918.918,0,0,0,.919-.919V150.6H228.881ZM248.067,154.3a.918.918,0,0,1,.919-.919h1.8a.918.918,0,0,1,.919.919v6.508a.918.918,0,0,1-.919.919h-1.8a.918.918,0,0,1-.919-.919Zm-15.211,0a.918.918,0,0,1,.919-.919h3.747a.918.918,0,0,1,.919.919v28.021a.918.918,0,0,1-.919.919h-3.747a.918.918,0,0,1-.919-.919Z",
    transform: "translate(-79.383 -72.174)",
    fill: "#ce1952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M182.672,69.776H142.248a2.227,2.227,0,0,0-2.266,2.18v12.1a2.227,2.227,0,0,0,2.266,2.18h5.411V78.424H145.75a.918.918,0,0,1,0-1.837h33.419a.919.919,0,0,1,0,1.837h-1.909v7.811h5.411a2.227,2.227,0,0,0,2.266-2.18v-12.1a2.225,2.225,0,0,0-2.264-2.18Z",
    fill: "#ce1952"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBayAtm);
export default __webpack_public_path__ + "static/media/ic-bayAtm.f35b3b94.svg";
export { ForwardRef as ReactComponent };